<template lang="pug">
    .login-form(v-loading='loading.data')
        .login-form-title(:class="titleClass")
        el-form.form-content(:model="form", ref="form")
            el-form-item(prop="username")
                el-input.gzzoc-input(type="text", :placeholder="$t('login.form.username')", v-model="form.username", :autofocus="true", autocomplete="off")
            el-form-item(prop="password")
                el-input.gzzoc-input(type="text", :placeholder="$t('login.form.password')", v-model="form.password", show-password)
            el-form-item(prop="code", v-if="show.captcha")
                .captcha
                    el-input.gzzoc-input(v-model="form.captcha", :placeholder="$t('login.form.captcha')", @keyup.enter.native="login")
                    a.captcha-img(href="javascript:;", @click="getCaptcha()")
                        img(:src="captchaUrl")
        el-button.gzzoc-button-primary(:loading="loading.login", @click="login") {{$t('login.form.login')}}
</template>

<script>
import md5 from 'md5';
import ls from '@/utils/local-storage';
import _ from 'lodash';
import CustomInput from '@/components/custom-input';

export default {
    components: {
        CustomInput,
    },
    data () {
        return {
            show: {
                captcha: false
            },
            loading: {
                data: false,
                login: false
            },
            form: {
                username: '',
                password: '',
                code: ''
            },
            captchaUrl: '',
            loginRule: {
                username: [
                    {
                        validator (rule, value, callback) {
                            if (/^\s*$/.test(_.trim(value))) {
                                callback(new Error(this.$t('login.form.usernameRequired')));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                password: [
                    {
                        validator (rule, value, callback) {
                            if (value === '') {
                                callback(new Error(this.$t('login.form.passwordRequired')));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            appid: 'f4ff2d67-1df4-41ff-87aa-fcc0a70a0f78',
            cluster: '',
            error: '',
        };
    },
    created () {
        this.loading.data = true;
        this.$http.get('pg/profile/get_configs').then(resp => {
            this.cluster = _.get(resp.body, 'value.cluster');
            this.loading.data = false;
        }, () => {
            this.$message.error(this.$t('requestFailed'));
            this.loading.data = false;
        });
    },
    methods: {
        login () {
            this.$refs['form'].validate(valid => {
                if (!valid) {
                    return;
                }

                const hashedPassword = md5(this.form.password);
                this.loading.login = true;

                this.form.username = _.trim(this.form.username);

                const local = window.location.protocol + '//' + window.location.host;
                const oauth = local + '/sso/oauth/token';
                const url = '/sso/passport/user/login?' +
                    'oauth=' + encodeURIComponent(oauth) +
                    '&cluster=' + encodeURIComponent(this.cluster) +
                    '&callback=' + encodeURIComponent(this.callback || (local + location.pathname))
                    + "&appid=" + this.appid;

                const param = {
                    username: this.form.username,
                    password: hashedPassword
                };

                if (this.captchaShow) {
                    param.captcha = this.form.captcha;
                }

                this.$http.post(url, param).then(resp => {
                    const respLocation = _.get(resp, 'body.value.Location');
                    if (respLocation) {
                        location.href = decodeURIComponent(respLocation);
                    } else {
                        this.$message.error(this.$t('login.form.loginError'));
                    }
                }, err => {
                    let e = _.get(err, 'data._error');
                    if (e.code === 460) { // 此状态码表示未初始化
                        // 用户初次登录，需要修改密码
                        // this.userInitModal = true;
                        // this.form.userid = e.value.userid;
                        // this.loginType = 'account';
                        this.$message.error(this.$t('login.form.loginErrorNeedModifyPassword'));
                    } else {
                        let detail = _.get(e, 'detail');
                        if (detail === 'no_such_user') {
                            detail = this.$t('login.form.loginErrorUsernameOrPassword');
                        }
                        this.$message.error(detail || this.$t('login.form.loginError'));
                    }
                    //添加验证码
                    let captcha = _.get(e, 'value.captcha');
                    if (captcha) {
                        this.captchaShow = true;
                        this.show.captcha = true;
                        this.captchaUrl = 'data:images/png;base64,' + captcha;
                    }
                }).finally(() => {
                    this.loading.login = false;
                });
            });
        },
        getCaptcha () {
            this.$http.get('/sso/oauth/user/captcha?username=' + _.trim(this.form.username)).then(resp => {
                this.captchaUrl = 'data:images/png;base64,' + _.get(resp, 'body.value');
            });
        }
    },
    computed: {
        titleClass () {
            let cls = ls.get('lang');
            return {
                'cn': cls === 'zh-CN',
                'en': cls === 'en'
            };
        }
    }
};
</script>

<style lang="sass">
    // .login-form
    //     input
    //         -webkit-box-shadow: 0 0 0 1000px white inset
    //         color: #000
    .captcha
        .el-input
            width: 70%
</style>

<style lang="sass" scoped>
    .login-form
        width: 400px
        height: 370px
        background: #fff
        border-radius: 16px
        padding: 32px 24px
        display: flex
        flex-direction: column
        align-items: center
        .captcha-img
            float: right
            margin-top: 5px
    .form-content
        width: 100%
    .login-form-title
        color: #222
        font-size: 24px
        line-height: 24px
        margin-bottom: 30px
        height: 98px
        width: 100%
        background: url(~public/images/gzzoc/login-title-cn.svg) no-repeat top left / 100% 100%
        &.en
            background-image: url(~public/images/gzzoc/login-title-en.svg)
</style>
